__turbopack_context__.v({
  "personContainer": "styles-module-scss-module__LnAVNa__personContainer",
  "personHeadshot": "styles-module-scss-module__LnAVNa__personHeadshot",
  "personUnderline": "styles-module-scss-module__LnAVNa__personUnderline",
});
